import { IconProps } from '../../Interfaces/Props';

const IconSection = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '20'}
      height={props.size ?? '20'}
      className={props.className}
      viewBox="0 0 24 24"
    >
      <rect width="24" height="24" fill="none" />
      <path
        fill="currentColor"
        d="M9.9 2H8.1A2.6 2.6 0 0 0 8 3v18c-.032.337.002.676.1 1h1.8c.098-.324.132-.663.1-1V3a2.6 2.6 0 0 0-.1-1"
        opacity="0.25"
      />
      <path fill="currentColor" d="M3 2h5v20H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1" />
      <path
        fill="currentColor"
        d="M10 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H10z"
        opacity="0.5"
      />
    </svg>
  );
};

export default IconSection;
